
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/imprint",
      function () {
        return require("private-next-pages/[lang]/imprint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/imprint"])
      });
    }
  